import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './BlogPostDetailPage.css';

const BlogPostDetailPage = ({ postId, onBack }) => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!postId) {
      setLoading(false);
      return;
    }
    const postRef = ref(database, `blog/${postId}`);
    const unsubscribe = onValue(postRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setPost({ id: postId, ...data });
      } else {
        setPost(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [postId]);

  const formatDate = (d) => {
    if (!d) return '';
    return new Date(d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  if (loading) {
    return (
      <div className="blog-detail-page">
        <div className="container">
          <p className="blog-detail-loading">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="blog-detail-page">
        <div className="container">
          <p className="blog-detail-empty">Yazı bulunamadı.</p>
          {onBack && (
            <button type="button" onClick={onBack} className="blog-detail-back-btn">
              ← Blog listesine dön
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="blog-detail-page">
      <article className="blog-detail-article">
        <div className="container">
          {onBack && (
            <button type="button" onClick={onBack} className="blog-detail-back-btn">
              ← Blog listesine dön
            </button>
          )}
          <header className="blog-detail-header">
            <h1 className="blog-detail-title">{post.title}</h1>
            {post.date && (
              <time className="blog-detail-date">{formatDate(post.date)}</time>
            )}
          </header>
          <div className="blog-detail-body">
            <p className="blog-detail-content">{post.content || post.excerpt || ''}</p>
          </div>
        </div>
      </article>
    </div>
  );
};

export default BlogPostDetailPage;
